import { EnumAmazonMarketplace, EnumAmazonProduct } from '../../../../../../constants/research';
import { ISearchLinkConfig, ISearchParameterConfig } from '../../../../data/search-links.interface';
import { AMAZON_CATEGORY_LIST, AMAZON_SORTING_LIST } from '../amazon-search.data';


/**------------------------------------------------------
 * Product Configurations
 */
const AMAZON_PRODUCT_LIST_COM: ISearchParameterConfig<EnumAmazonProduct>[] = [
	{
		code		: EnumAmazonProduct.All,
		name		: 'All Products',
		parameters 	: {
			language	: 'en_US'
		}
	},
	{
		// https://www.amazon.com/s?k=dog&i=fashion-novelty&rh=p_6%3AATVPDKIKX0DER&s=featured&hidden-keywords=Lightweight%2C+Classic+fit%2C+Double-needle+sleeve+and+bottom+hem+-Longsleeve+-Raglan+-Vneck+-Tanktop
		code		: EnumAmazonProduct.Shirt,
		name		: 'T-Shirt',
		parameters 	: {
			language		 : 'en_US',
			i				 : 'fashion-novelty',
			rh				 : 'p_6%3AATVPDKIKX0DER', // cspell:disable-line
			'hidden-keywords': 'Lightweight%2C+Classic+fit%2C+Double-needle+sleeve+and+bottom+hem+-Longsleeve+-Raglan+-Vneck+-Tanktop'
		}
	},
	{
		// https://www.amazon.com/s?k=dog&i=fashion-novelty&bbn=12035955011&rh=p_6%3AATVPDKIKX0DER&hidden-keywords=This+premium+t-shirt+is+made+of+lightweight+fine+jersey+fabric+Mens+fit+runs+small+size+up+for+a+looser+fit
		code		: EnumAmazonProduct.PremiumShirt,
		name		: 'Premium T-Shirt',
		parameters 	: {
			language	: 'en_US',
			i			: 'fashion-novelty',
			bbn			: '12035955011',
			rh			: 'p_6%3AATVPDKIKX0DER', // cspell:disable-line
			'hidden-keywords': 'This+premium+t-shirt+is+made+of+lightweight+fine+jersey+fabric+Mens+fit+runs+small+size+up+for+a+looser+fit'
		}
	},
	{
		// https://www.amazon.com/s?k=dog&i=fashion-novelty&rh=p_6%3AATVPDKIKX0DER&hidden-keywords=v-neck%20Lightweight%2C%20Classic%20fit%2C%20Double-needle%20sleeve%20and%20bottom%20hem
		code		: EnumAmazonProduct.VNeck,
		name		: 'V-Neck',
		parameters 	: {
			language	: 'en_US',
			i			: 'fashion-novelty',
			rh			: 'p_6%3AATVPDKIKX0DER', // cspell:disable-line
			'hidden-keywords': 'v-neck%20Lightweight%2C%20Classic%20fit%2C%20Double-needle%20sleeve%20and%20bottom%20hem'
		},
		queryOptions: {
			prefix		: '',
			postfix		: '+vneck'
		}
	},
	{
		// https://www.amazon.com/s?k=dog&i=fashion-novelty&rh=p_6%3AATVPDKIKX0DER&hidden-keywords=fit+tank+top%22Tank+Top%22
		code		: EnumAmazonProduct.TankTop,
		name		: 'Tank Top',
		parameters 	: {
			language	: 'en_US',
			i			: 'fashion-novelty',
			rh			: 'p_6%3AATVPDKIKX0DER', // cspell:disable-line
			'hidden-keywords': 'fit+tank+top%22Tank+Top%22'
		}
	},
	{
		// https://www.amazon.com/s?k=dog&i=fashion-novelty&bbn=12035955011&rh=p_6%3AATVPDKIKX0DER&hidden-keywords=%22Lightweight%2C+Classic+fit%2C+Double-needle+sleeve+and+bottom+hem%22+++%22long+sleeve%22
		code		: EnumAmazonProduct.LongSleeve,
		name		: 'Long Sleeve',
		parameters 	: {
			language	: 'en_US',
			i			: 'fashion-novelty',
			bbn			: '12035955011',
			rh			: 'p_6%3AATVPDKIKX0DER', // cspell:disable-line
			'hidden-keywords': '%22Lightweight%2C+Classic+fit%2C+Double-needle+sleeve+and+bottom+hem%22+++%22long+sleeve%22'
		}
	},
	{
		// https://www.amazon.com/s?k=dog+raglan&i=fashion-novelty&bbn=12035955011&rh=p_6%3AATVPDKIKX0DER
		code		: EnumAmazonProduct.Raglan,
		name		: 'Raglan',
		parameters 	: {
			language	: 'en_US',
			i			: 'fashion-novelty',
			bbn			: '12035955011',
			rh			: 'p_6%3AATVPDKIKX0DER' // cspell:disable-line
		},
		queryOptions: {
			prefix		: '',
			postfix		: '+raglan'
		}
	},
	{
		// https://www.amazon.com/s?k=dog&i=fashion-novelty&bbn=12035955011&rh=p_6%3AATVPDKIKX0DER&hidden-keywords=%228.5+oz%2C+Classic+fit%2C+Twill-taped+neck%22+%22sweatshirt%22+-hoodie
		code		: EnumAmazonProduct.Sweatshirt,
		name		: 'Sweatshirt',
		parameters 	: {
			language	: 'en_US',
			i			: 'fashion-novelty',
			bbn			: '12035955011',
			rh			: 'p_6%3AATVPDKIKX0DER', // cspell:disable-line
			'hidden-keywords': '%228.5+oz%2C+Classic+fit%2C+Twill-taped+neck%22+%22sweatshirt%22+-hoodie'
		}
	},
	{
		// https://www.amazon.com/s?i=fashion&rh=p_6%3AATVPDKIKX0DER&hidden-keywords=8.5%20oz%2C%20Classic%20fit%2C%20Twill-taped%20neck+hoodie&language=en_US
		code		: EnumAmazonProduct.Hoodie,
		name		: 'Hoodie',
		parameters 	: {
			language	: 'en_US',
			i			: 'fashion',
			rh			: 'p_6%3AATVPDKIKX0DER', // cspell:disable-line
			'hidden-keywords': '8.5%20oz%2C%20Classic%20fit%2C%20Twill-taped%20neck+hoodie'
		}
	},
	{
		// https://www.amazon.com/s?k=%22PopSockets%22+%22PopGrip%22+-MagSafe+-Official&i=mobile&s=date-desc-rank&language=en_US&rh=p_6%3AATVPDKIKX0DER
		code		: EnumAmazonProduct.PopSocket,
		name		: 'PopSocket',
		parameters 	: {
			language	: 'en_US',
			i			: 'mobile',
			rh			: 'p_6%3AATVPDKIKX0DER' // cspell:disable-line
		},
		queryOptions: {
			prefix		: '',
			postfix		: '+%22PopSockets%22+%22PopGrip%22+-MagSafe+-Official'
		}
	},
	{
		// https://www.amazon.com/s?k=dog&i=mobile&rh=p_6%3AATVPDKIKX0DER&hidden-keywords=Two-part+protective+case+made+from+a+premium+scratch-resistant+polycarbonate+shell+and+shock+absorbent+TPU+liner+protects+against+drops&sprefix=%2Cmobile%2C797
		code		: EnumAmazonProduct.PhoneCase,
		name		: 'Phone Case',
		parameters 	: {
			language	: 'en_US',
			i			: 'mobile',
			rh			: 'p_6%3AATVPDKIKX0DER', // cspell:disable-line
			sprefix		: '%2Cmobile%2C797', // cspell:disable-line
			'hidden-keywords': 'Two-part+protective+case+made+from+a+premium+scratch-resistant+polycarbonate+shell+and+shock+absorbent+TPU+liner+protects+against+drops'
		}
	},
	{
		// https://www.amazon.com/s?k=dog&rh=n%3A3732321%2Cp_6%3AATVPDKIKX0DER&hidden-keywords=100%25+spun-polyester+fabric+Double-sided+print+Spot+clean%2Fdry+clean+only+Filled+with+100%25+polyester+and+sewn+closed
		code		: EnumAmazonProduct.ThrowPillow,
		name		: 'Throw Pillows',
		parameters 	: {
			language	: 'en_US',
			rh			: 'n%3A3732321%2Cp_6%3AATVPDKIKX0DER', // cspell:disable-line
			'hidden-keywords': '100%25+spun-polyester+fabric+Double-sided+print+Spot+clean%2Fdry+clean+only+Filled+with+100%25+polyester+and+sewn+closed' // cspell:disable-line
		}
	},
	{
		// https://www.amazon.de/s?k=[SEARCH]&s=[SORTING]&page=[PAGE]&i=stripbooks&hidden-keywords=independently+published&__mk_de_DE=%C3%85M%C3%85%C5%BD%C3%95%C3%91&qid=1601804685&ref=sr_pg_2
		code		: EnumAmazonProduct.KDP,
		name		: 'Kindle Book (KDP)',
		parameters 	: {
			language	: 'en_US',
			i			: 'stripbooks-intl-ship',
			qid			: '1601804586',
			'hidden-keywords': 'independently+published'
		}
	},
	{
		// https://www.amazon.com/s?k=[SEARCH]&s=[SORTING]&page=[PAGE]&i=kitchen&hidden-keywords=Merch+on+Demand+Ceramic+Coffee+Mug&rh=p_6%3AATVPDKIKX0DER&language=en_US
		code		: EnumAmazonProduct.CeramicMug,
		name		: 'Ceramic Mug',
		parameters 	: {
			language	: 'en_US',
			i			: 'kitchen',
			rh			: 'p_6%3AATVPDKIKX0DER',
			'hidden-keywords': 'Merch+on+Demand+Ceramic+Coffee+Mug'
		}
	},
	{
		// https://www.amazon.com/s?k=[SEARCH]&s=[SORTING]&page=[PAGE]&i=kitchen&hidden-keywords=Merch+on+Demand+Stainless+Steel+Insulated+Tumbler&rh=p_6%3AATVPDKIKX0DER&language=en_US
		code		: EnumAmazonProduct.Tumbler,
		name		: 'Tumbler',
		parameters 	: {
			language	: 'en_US',
			i			: 'kitchen',
			rh			: 'p_6%3AATVPDKIKX0DER',
			'hidden-keywords': 'Merch+on+Demand+Stainless+Steel+Insulated+Tumbler'
		}
	},
	{
		// https://www.amazon.com/s?k=[SEARCH]&s=[SORTING]&page=[PAGE]&i=fashion-womens-handbags&hidden-keywords=Graphic&rh=n%3A16977746011%2Cp_6%3AATVPDKIKX0DER&language=en_US
		code		: EnumAmazonProduct.ToteBag,
		name		: 'Tote Bag',
		parameters 	: {
			language	: 'en_US',
			i			: 'fashion-womens-handbags',
			rh			: 'n%3A16977746011%2Cp_6%3AATVPDKIKX0DER',
			'hidden-keywords': 'Graphic'
		}
	},
	{
		// https://www.amazon.com/s?k=[SEARCH]&s=[SORTING]&page=[PAGE]&i=fashion-mens&hidden-keywords=Merch+on+Demand+Comfort+Colors+Heavyweight+T+Shirt&rh=p_6%3AATVPDKIKX0DER&language=en_US
		code		: EnumAmazonProduct.ComfortColorsHeavyweightTShirt,
		name		: 'Comfort Colors Heavyweight T-Shirt',
		parameters 	: {
			language	: 'en_US',
			i			: 'fashion-mens',
			rh			: 'p_6%3AATVPDKIKX0DER',
			'hidden-keywords': 'Merch+on+Demand+Comfort+Colors+Heavyweight+T+Shirt'
		}
	},
	{
		// https://www.amazon.com/s?k=[SEARCH]&s=[SORTING]&page=[PAGE]&i=fashion-mens&hidden-keywords=Merch+on+Demand+Performance+Polo+Shirt&rh=p_6%3AATVPDKIKX0DER&language=en_US
		code		: EnumAmazonProduct.PerformancePolo,
		name		: 'Performance Polo Shirt',
		parameters 	: {
			language	: 'en_US',
			i			: 'fashion-mens',
			rh			: 'p_6%3AATVPDKIKX0DER',
			'hidden-keywords': 'Merch+on+Demand+Performance+Polo+Shirt'
		}
	},
	{
		// https://www.amazon.com/s?k=[SEARCH]&s=[SORTING]&page=[PAGE]&i=fashion-mens&hidden-keywords=Merch+on+Demand+Performance+Quarter+Zip+Top&rh=p_6%3AATVPDKIKX0DER&language=en_US
		code		: EnumAmazonProduct.PerformanceQuarterZip,
		name		: 'Performance Quarter Zip',
		parameters 	: {
			language	: 'en_US',
			i			: 'fashion-mens',
			rh			: 'p_6%3AATVPDKIKX0DER',
			'hidden-keywords': 'Merch+on+Demand+Performance+Quarter+Zip+Top'
		}
	},
	{
		code: EnumAmazonProduct.PerformanceShirt,
		name: 'Performance T-Shirt',
		parameters: { i: 'fashion-novelty', rh: 'p_6%3AATVPDKIKX0DER' },
		queryOptions: { prefix: '', postfix: encodeURIComponent(' performance t-shirt') }
	},
	{
		code: EnumAmazonProduct.ComfortColorsSweatshirt,
		name: 'Comfort Colors Sweatshirt',
		parameters: { i: '', rh: 'p_6%3AATVPDKIKX0DER%2Cp_36%3A3300-' },
		queryOptions: { prefix: '', postfix: encodeURIComponent(' "comfort colors adult sweatshirt"') }
	},
	{
		code: EnumAmazonProduct.ComfortColorsCropSweatshirt,
		name: 'Comfort Colors Crop Sweatshirt',
		parameters: { i: 'fashion-novelty', rh: 'p_6%3AATVPDKIKX0DER' },
		queryOptions: { prefix: '', postfix: encodeURIComponent(' comfort colors crop sweatshirt') }
	},
	{
		code: EnumAmazonProduct.CropTop,
		name: 'Crop Top',
		parameters: { i: 'fashion-novelty', rh: 'p_6%3AATVPDKIKX0DER' },
		queryOptions: { prefix: '', postfix: encodeURIComponent(' "comfort colors crop top"') }
	},
	{
		code: EnumAmazonProduct.ZipHoodie,
		name: 'Zip Hoodie',
		parameters: { i: 'fashion-novelty', rh: 'p_6%3AATVPDKIKX0DER%2Cp_36%3A-5499' },
		queryOptions: { prefix: '', postfix: encodeURIComponent(' zip hoodie') }
	},
	{
		code: EnumAmazonProduct.PerformanceHoodie,
		name: 'Performance Hoodie',
		parameters: { i: '', rh: 'p_6%3AATVPDKIKX0DER%2Cp_36%3A-5499' },
		queryOptions: { prefix: '', postfix: encodeURIComponent(' performance hoodie') }
	},
	{
		code: EnumAmazonProduct.BaseballHat,
		name: 'Baseball Hat',
		parameters: { i: '', rh: 'p_6%3AATVPDKIKX0DER%2Cp_36%3A1999-2399' },
		queryOptions: { prefix: '', postfix: encodeURIComponent(' "printed baseball hat"') }
	},
	{
		code: EnumAmazonProduct.TruckerHat,
		name: 'Trucker Hat',
		parameters: { i: 'fashion-novelty', rh: 'n%3A2474972011%2Cp_6%3AATVPDKIKX0DER%2Cp_36%3A1999-2399' },
		queryOptions: { prefix: '', postfix: encodeURIComponent(' trucker hat with adjustable mesh back') }
	},
	{
		code: EnumAmazonProduct.SportSunVisor,
		name: 'Sport Sun Visor',
		parameters: { i: 'fashion-novelty', rh: 'n%3A2474972011%2Cp_6%3AATVPDKIKX0DER%2Cp_36%3A1799-2199' },
		queryOptions: { prefix: '', postfix: encodeURIComponent(' sport sun visor') }
	},
	{
		code: EnumAmazonProduct.SportBackpack,
		name: 'Sport Backpack',
		parameters: { i: '', rh: 'p_6%3AATVPDKIKX0DER%2Cp_36%3A4299-4699' },
		queryOptions: { prefix: '', postfix: encodeURIComponent(' "sport backpack"') }
	},
	{
		code: EnumAmazonProduct.LaptopSleeve,
		name: 'Laptop Sleeve',
		parameters: { i: 'electronics', rh: 'n%3A335609011%2Cp_6%3AATVPDKIKX0DER%2Cp_36%3A2599-2999' },
		queryOptions: { prefix: '', postfix: encodeURIComponent(' "graphic laptop sleeve"') }
	},
	{
		code: EnumAmazonProduct.MousePad,
		name: 'Mouse Pad',
		parameters: { i: 'office-products', rh: 'n%3A705323011%2Cp_6%3AATVPDKIKX0DER%2Cp_36%3A1399-1799' },
		queryOptions: { prefix: '', postfix: encodeURIComponent(' "graphic mouse pad"') }
	},
	{
		code: EnumAmazonProduct.ThrowBlanket,
		name: 'Throw Blanket',
		parameters: { i: 'garden', rh: 'n%3A14058581%2Cp_6%3AATVPDKIKX0DER%2Cp_36%3A2899-3899' },
		queryOptions: { prefix: '', postfix: encodeURIComponent(' "graphic" "throw blanket"') }
	},
	{
		code: EnumAmazonProduct.UnframedPoster,
		name: 'Unframed Poster',
		parameters: { i: 'garden', rh: 'n%3A381142011%2Cp_6%3AATVPDKIKX0DER%2Cp_36%3A1199-1999' },
		queryOptions: { prefix: '', postfix: encodeURIComponent(' "unframed poster"') }
	},
	{
		code: EnumAmazonProduct.TravelTumbler,
		name: 'Stainless Steel Travel Tumbler',
		parameters: { i: 'kitchen', rh: 'p_6%3AATVPDKIKX0DER%2Cp_36%3A2999-3399' },
		queryOptions: { prefix: '', postfix: encodeURIComponent(' "stainless steel travel tumbler"') }
	},
	{
		code: EnumAmazonProduct.WaterBottle,
		name: 'Water Bottle',
		parameters: { i: 'sporting', rh: 'n%3A3395091%2Cp_6%3AATVPDKIKX0DER%2Cp_36%3A2899-3299' },
		queryOptions: { prefix: '', postfix: encodeURIComponent(' "stainless steel insulated water bottle"') }
	},
	{
		code: EnumAmazonProduct.HardcoverJournal,
		name: 'Hardcover Journal',
		parameters: { i: 'office-products', rh: 'n%3A490756011%2Cp_6%3AATVPDKIKX0DER%2Cp_36%3A1699-2099' },
		queryOptions: { prefix: '', postfix: encodeURIComponent(' "hardcover journal, black"') }
	},
	{
		code: EnumAmazonProduct.RetractablePen,
		name: '12-Pack Retractable Pens',
		parameters: { i: 'office-products', rh: 'n%3A6156513011%2Cp_6%3AATVPDKIKX0DER%2Cp_36%3A1399-1799' },
		queryOptions: { prefix: '', postfix: encodeURIComponent(' "12 pack retractable pens"') }
	}
];


/**------------------------------------------------------
 * Amazon Configuration
 */
export const AMAZON_CONFIG_COM: ISearchLinkConfig = {
	marketplace		: EnumAmazonMarketplace.COM,
	websiteUrl		: {
		home		: 'https://www.amazon.com/',
		login		: 'https://www.amazon.com/ap/signin?openid.identity=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select&openid.assoc_handle=usflex&openid.mode=checkid_setup&openid.claimed_id=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select&openid.ns=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0',
		search		: 'https://www.amazon.com/s?k=[SEARCH]&page=[PAGE]'
	},
	pageLimit		: 400,
	sortings		: AMAZON_SORTING_LIST,
	products		: AMAZON_PRODUCT_LIST_COM,
	category	    : AMAZON_CATEGORY_LIST,
	options 		: {
		emptySearch : true
	}
};
